function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import TextInput from './TextInput';
import Icon from './Icon';
import Scrollbars from './Scrollbars';

import './Typeahead.css';

var Typeahead = function (_Component) {
  _inherits(Typeahead, _Component);

  function Typeahead(props) {
    _classCallCheck(this, Typeahead);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleSelect = function () {
      var cursorRow = _this.getCursorRow();

      console.log('cursor', _this.state.cursor);
      console.log('results', _this.props.results);
      console.log('cursor row', cursorRow);

      if (cursorRow) {
        _this.props.onSelect(cursorRow);
      }

      _this.reset();
    };

    _this.handleResultMouseover = function (index) {
      _this.setCursor(index);
    };

    _this.handleResultMousedown = function () {
      _this.setState({
        resultMousedown: true
      });
    };

    _this.handleResultMouseup = function () {
      _this.setState({
        resultMousedown: false
      });
    };

    _this.handleResultsClick = function () {
      _this.handleSelect();
    };

    _this.handleQuery = function () {
      console.log('handle query', _this.state.inputValue);
      _this.props.onQuery(_this.state.inputValue);
    };

    _this.handleFocus = function () {
      _this.handleQuery();

      _this.setState({
        resultsVisible: true
      });
    };

    _this.handleBlur = function () {
      if (_this.state.resultMousedown) {
        // Don't blur if clicking on a result
        return;
      }

      _this.setState({
        resultsVisible: false
      });
    };

    _this.handleType = function (value) {
      _this.setState({
        inputValue: value,
        cursor: 0
      }, function () {
        _this.handleQuery();
      });
    };

    _this.handleChange = function (value) {
      _this.handleType(value);
    };

    _this.handleKeyDown = function (e) {
      if (e.key === 'Escape') {
        _this.reset();
        return;
      }

      if (_this.props.results.length !== 0) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();

          if (_this.state.cursor === _this.props.results.length - 1) {
            return;
          }

          _this.moveCursor(1);

          return;
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();

          if (_this.state.cursor < 0) {
            return;
          }

          _this.moveCursor(-1);

          return;
        } else if (e.key === 'Enter') {
          e.preventDefault();
          _this.handleSelect();

          return;
        }
      }
    };

    _this.state = {
      inputValue: props.inputValue || '',
      cursor: 0,
      resultsVisible: false,
      resultMousedown: false
    };
    return _this;
  }

  Typeahead.prototype.componentDidMount = function componentDidMount() {
    this.ensureCursoredResultVisible();
  };

  Typeahead.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.cursor !== prevState.cursor) {
      this.ensureCursoredResultVisible();
    }
  };

  Typeahead.prototype.reset = function reset() {
    this.setState({
      inputValue: '',
      cursor: 0,
      resultsVisible: false
    });

    console.log('textinput', this.textInput);
    console.log('textinput input', this.textInput.input);

    this.textInput.input.current.blur();
  };

  Typeahead.prototype.getCursorRow = function getCursorRow() {
    if (this.state.cursor == null) {
      return null;
    }

    return this.props.results[this.state.cursor];
  };

  Typeahead.prototype.setCursor = function setCursor(cursor) {
    this.setState({
      cursor: cursor
    });
  };

  Typeahead.prototype.moveCursor = function moveCursor(cursorChange) {
    this.setCursor(this.state.cursor + cursorChange);
  };

  Typeahead.prototype.isCursoredResult = function isCursoredResult(i) {
    return this.state.cursor === i;
  };

  Typeahead.prototype.ensureCursoredResultVisible = function ensureCursoredResultVisible() {
    if (this.cursoredResult) {
      var item = this.cursoredResult;
      var menu = this.dropdownMenu.children[0].children[0];

      var itemTop = item.offsetTop;
      var itemBottom = itemTop + item.offsetHeight;
      var menuScrollTop = menu.scrollTop;
      var menuHeight = this.dropdownMenu.offsetHeight;

      if (itemTop <= menuScrollTop) {
        menu.scrollTop = itemTop;
      } else if (itemBottom > menuHeight + menuScrollTop) {
        menu.scrollTop = itemBottom - menuHeight;
      }
    }
  };

  Typeahead.prototype.getNoResultsContent = function getNoResultsContent() {
    if (this.props.noResultsContent) {
      return this.props.noResultsContent;
    }
    return 'No results';
  };

  Typeahead.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      { className: 'Typeahead', style: { width: this.props.width } },
      React.createElement(
        'div',
        { className: 'Typeahead-input' },
        React.createElement(Icon, { name: 'search', className: 'Typeahead-input-search-icon' }),
        React.createElement(Icon, { name: 'caret-down', fill: true, className: 'Typeahead-input-caret-icon' }),
        React.createElement(TextInput, { ref: function ref(textInput) {
            return _this2.textInput = textInput;
          }, label: this.props.label, value: this.state.inputValue, onChange: this.handleChange, onKeyDown: this.handleKeyDown, onFocus: this.handleFocus, onBlur: this.handleBlur, placeholder: this.props.placeholder })
      ),
      React.createElement(
        'div',
        { className: 'Typeahead-results-container' },
        React.createElement(
          'div',
          { className: 'Typeahead-results', onClick: this.handleResultsClick, onMouseDown: this.handleResultMousedown, onMouseUp: this.handleResultMouseup, 'data-visible': this.state.resultsVisible },
          React.createElement(
            'div',
            { ref: function ref(dropdownMenu) {
                _this2.dropdownMenu = dropdownMenu;
              }, className: 'Typeahead-result-items' },
            React.createElement(
              Scrollbars,
              { height: 195 },
              this.props.results.length === 0 && React.createElement(
                'div',
                { className: 'Typeahead-no-results' },
                this.getNoResultsContent()
              ),
              this.props.results.length !== 0 && this.props.results.map(function (result, i) {
                var cursored = _this2.isCursoredResult(i);
                return React.createElement(
                  'div',
                  { ref: function ref(result) {
                      if (cursored) {
                        _this2.cursoredResult = result;
                      }
                    }, className: 'Typeahead-result', key: result.key, 'data-cursored': cursored, onMouseOver: _this2.handleResultMouseover.bind(null, i) },
                  React.createElement(
                    'div',
                    { className: 'Typeahead-result-icon' },
                    result.icon
                  ),
                  React.createElement(
                    'div',
                    { className: 'Typeahead-result-label' },
                    result.label
                  )
                );
              })
            )
          )
        )
      )
    );
  };

  return Typeahead;
}(Component);

export default Typeahead;